import { useQuery } from 'react-query';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { queryKeys } from './queryKeys';

export enum ExternalSystemId {
  Orion = 2,
  Riskalyze = 5,
}

export interface AssetClassDTO {
  color: string | null;
  color_group: number;
  id: number;
  name: string | null;
  y: number;
}

export interface ModelDTO {
  assetAllocationInputModel: AssetClassDTO[];
  riskScore: number | null;
  hypotheticalReturn: number | null;
  id: string;
  orionModelId: number | null;
  portfolioDescription: string | null;
  portfolioName: string;
  riskRange: {
    from: number;
    to: number;
  };
}

export interface ModelGroupDTO {
  adviserId: number | null;
  createdBy: {
    name: string;
    email: string;
  } | null;
  externalSystem: ExternalSystemId | null;
  groupId: string;
  groupName: string;
  modelPortfolios: ModelDTO[];
}

export interface ModelGroupsDTO {
  modelPortfoliosGroups: ModelGroupDTO[];
  options: {
    defaultAssetAllocation: AssetClassDTO[];
    hasOrionModels: boolean;
  };
}

const fetchModelGroups = (): Promise<ModelGroupsDTO> => {
  return authFetch('/Adviser/ModelPortfoliosGroups');
};

export const useModelGroupsQuery = () => {
  return useQuery(
    queryKeys.modelGroups(),

    () => fetchModelGroups(),
  );
};
